import { useEffect, useState } from 'react'

/** Порог мобильного экрана (смартфон в портретной ориентации). */
export const MOBILE_BREAKPOINT = 768

/**
 * Порог компактного ЛЭЙАУТА кассы (одна колонка + нижняя панель).
 * Отделён от MOBILE_BREAKPOINT: на ноутбуке 900px нужен одноколоночный лэйаут,
 * но устройство по-прежнему стационарное (аппаратный 2D-сканер, не камера).
 */
export const POS_COMPACT_BREAKPOINT = 1024

/**
 * Хук: true, если ширина вьюпорта меньше порога (смартфон).
 * Реагирует на resize/ориентацию. Безопасен при SSR (стартует с false).
 */
export function useIsMobile(breakpoint: number = MOBILE_BREAKPOINT): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() =>
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  )

  useEffect(() => {
    if (typeof window === 'undefined') return
    const onResize = () => setIsMobile(window.innerWidth < breakpoint)
    onResize()
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [breakpoint])

  return isMobile
}
